import { useEffect, useState } from "react";
import { useLocation } from "react-router";

export function useWindowScrolled() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(() => window.scrollY > 0);

  useEffect(() => {
    setScrolled(window.scrollY > 0);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return scrolled;
}
